import React, { FunctionComponent } from 'react';
import { Radio, RadioProps } from 'reakit/Radio';
import classnames from 'classnames';

export interface CKRadioProps extends RadioProps {
  className?: string;
  isDisabled?: boolean;
  label: string | React.ReactNode;
}

export const CKRadio: FunctionComponent<CKRadioProps> = ({
  isDisabled,
  label,
  id,
  className,
  ...rest
}) => {
  const radioClass = classnames(`ck-radio`, className);
  return (
    <div className={radioClass}>
      <Radio
        disabled={isDisabled}
        id={id}
        className="ck-radio-input"
        {...rest}
      />
      <label htmlFor={id} className="ck-radio-label">
        <div className="ck-radio-box">
          <div className="ck-radio-knob"></div>
        </div>
        <span className="ck-radio-text">{label}</span>
      </label>
    </div>
  );
};

export default CKRadio;
